import React, {Component} from 'react';

export default class Title extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showedit: false,
      open: this.props.isOpen
    };
    this.click = this.click.bind(this);
  }

  click() {
    this.props.edit.onClick();
    this.setState({
      showedit: false
    });
  }

  render() {
    let _self = this;
    return <div className={this.state.open ? 'row opened' : 'row'}>
      <div className="col s12">
        <div className={'dashboard_precios_title ' + (this.props.isGray ? ' gray ' : '') + (this.props.className ? this.props.className : '')}>
            <div className="row">
                <div className="col s12">
                    <span>{this.props.hasIcon && <img alt="" className={this.state.open ? 'opened' : ''} onClick={() => { _self.setState({open: !_self.state.open}, function() { _self.props.toggle(); }) }} src="/static/imgs/angle-right.svg" />}</span>
                    <h2 className={this.props.hasIcon ? ' hasIcon' : ''}>{this.props.text}</h2>
                    {this.props.edit && <div className={'edit-panel' + (this.state.showedit ? ' active' : '')}>
                      <div className="edit-panel-header">
                        <i className="fas fa-ellipsis-h" onClick={() => { _self.setState({ showedit: !_self.state.showedit }) }}></i>
                      </div>
                      <div className="edit-panel-content" onClick={this.click}>
                          <i className={this.props.edit.icon}></i>
                          <span>{this.props.edit.label}</span>
                        </div>
                    </div>}
                </div>
            </div>
        </div>
      </div>
    </div>
  }

}


// WEBPACK FOOTER //
// ./src/containers/base/title.js